import React, { useContext, useEffect } from 'react';
import { Container, Row } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import Widget from './Widget';
import RecentComment from './RecentComment';
import RecentArticleTable from './RecentArticleTable';
import RecentContactMessage from './RecentContactMessage';
import { DashboardContext } from '../../context/DashboardContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DashboardBlog = () => {
  document.title = 'داشبورد | مدیریت فات 90';

  const { fetchDashboardData, loading, error } = useContext(DashboardContext);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  return (
    <React.Fragment>
      <div className="page-content" dir="rtl">
        <ToastContainer closeButton={false} limit={1} />
        <Container fluid>
          <BreadCrumb title="داشبورد" pageTitle="نگاه کلی" />
          {loading ? (
            <div className="py-4 text-center">
              <lord-icon
                src="https://cdn.lordicon.com/msoeawqm.json"
                trigger="loop"
                colors="primary:#25a0e2,secondary:#00bd9d"
                style={{ width: '72px', height: '72px' }}
              ></lord-icon>
              <h5 className="mt-4">در حال بارگذاری...</h5>
            </div>
          ) : error ? (
            <div className="py-4 text-center">
              <lord-icon
                src="https://cdn.lordicon.com/msoeawqm.json"
                trigger="loop"
                colors="primary:#25a0e2,secondary:#00bd9d"
                style={{ width: '72px', height: '72px' }}
              ></lord-icon>
              <h5 className="mt-4">{error}</h5>
            </div>
          ) : (
            <Row>
              <Widget />
              <RecentComment />
              <RecentContactMessage />
              <RecentArticleTable />
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardBlog;